import axios, { AxiosResponse } from 'axios';
import { IUserInformationFormValues } from '../../components/pages/Setting/Access/User/UserInformation';
import { IMemberGroupFieldValue, IUserMemberManageFormValues } from '../../components/pages/Setting/Access/User/UserMemberManage';
import { IPermission } from '../../compiler/global.interface';
import md5 from 'md5'
import { IResetPasswordFormValues } from '../../components/global/Modal/ResetPasswordModal';
import metaEnv from '../../helper/metaEnv'

export async function APIGetAllUsers() {
    try {
        let result: AxiosResponse = await axios.get('/user-master')
        return result.data
    } catch (error) {
        throw new Error(`Error At APIGetAllUsers : ${error}`);
    }
}


export async function APIGetUserGroupByUUID(uuid) {
    try {
        let result: AxiosResponse = await axios.get(`/user-group/${uuid}`)
        return result.data
    } catch (error) {
        throw new Error(`Error At APIGetUserGroupByUUID : ${error}`);
    }
}

export async function APIGetUserPermissionByUUID(uuid) {
    try {
        let result: AxiosResponse = await axios.get(`/roles-user-permission/user/${uuid}`)
        return result.data
    } catch (error) {
        throw new Error(`Error At APIGetUserPermissionByUUID : ${error}`);
    }
}

export async function APICreateUser(payload: IUserInformationFormValues) {

    const body = {
        avatar: payload.avatar || "",
        username: payload.username?.trim(),
        password: md5(payload.password),
        firstname: payload.firstname?.trim(),
        lastname: payload.lastname?.trim(),
        email: payload.email?.trim()
    }

    try {
        let result: AxiosResponse = await axios.post('/user-master', body)
        return result.data
    } catch (error) {
        throw new Error(`Error At APICreateUser : ${error}`);
    }
}

export async function APIUpdateUserByUUID(uuid, payload: IUserInformationFormValues) {

    let body = {
        avatar:payload.avatar,
        firstname: payload.firstname?.trim(),
        is_active: payload.is_active,
        lastname: payload.lastname?.trim(),
        email: payload.email
    }

    try {
        let result: AxiosResponse = await axios.patch(`/user-master/update-profile/${uuid}`,body)
        return result.data
    } catch (error) {
        throw new Error(`Error At APIUpdateUserByUUID : ${error}`);
    }
}

export async function APIUpdateUserGroupByUUID(uuid: string | null, payload: IMemberGroupFieldValue[]) {

    let body = {
        user_uuid: uuid,
        groups: payload.map(group => ({
            id: group.id,
            group_master_uuid: group.group_master_uuid,
            is_remove: group?.is_remove ?? 0
        }))
    }

    try {
        let result: AxiosResponse = await axios.post('/user-group/group', body)
        return result.data
    } catch (error) {
        throw new Error(`Error At APIUpdateUserGroupByUUID : ${error}`);
    }
}

export async function APIUpdateUserPermissionByUUID(uuid: string | null, payload: IPermission[]) {

    let body = {
        user_uuid: uuid,
        roles: payload?.map(role => ({
            roles_code: role.roles_code,
            read: role.read,
            create: role.create,
            update: role.update,
            delete: role.delete,
            approve: role.approve,
        }))
    }

    try {
        let result: AxiosResponse = await axios.post('/roles-user-permission', body)
        return result.data
    } catch (error) {
        throw new Error(`Error At APIUpdateUserPermissionByUUID : ${error}`);
    }
}

export async function APIUpdateUserPasswordByUUID(uuid: string | null, payload: IResetPasswordFormValues) {
    let body = {
        user_uuid:uuid,
        newPassword: md5(payload.newPassword)
    }
    try {
        let result: AxiosResponse = await axios.patch(`/user-master/reset-password`, body)
        return result.data
    } catch (error) {
        throw new Error(`Error At APIUpdateUserPasswordByUUID : ${error}`);
    }
}